<template>
    <div class="FormItem form-group" :class="{ 'has-error': form.errors.has(field) }">
        <slot></slot>
        <slot name="help-block">
            <span v-show="form.errors.has(field)" class="help-block" :class="helpBlockClass">{{
                getLocalizedError()
            }}</span>
        </slot>
    </div>
</template>

<script type="text/babel">
export default {
    props: ['field', 'form', 'helpBlockClass', 'helpBlockLabel'],

    methods: {
        getLocalizedError() {
            let error = this.form.errors.get(this.field)
            let attributeName = this.field
            if (error && error.substring(0, attributeName.length) === attributeName) {
                error = error.replace(attributeName, this.getLabel())
            }

            return error
        },

        getLabel() {
            let label = this.helpBlockLabel
                ? this.helpBlockLabel
                : $(this.$el)
                      .find('.control-label')
                      .text()

            return label ? label : this.guessAttributeName
        },

        guessAttributeName() {
            return this.field.replaceAll('_', ' ')
        },
    },
}
</script>
